import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';

@Component({
    selector: 'xqnr-backdrop',
    templateUrl: './backdrop.component.pug',
    styleUrls: ['./backdrop.component.scss'],
    animations: [
        trigger('showHide', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class BackdropComponent implements OnInit {
  constructor(
    public backdrop: BackdropService
  ) {}

  ngOnInit(): void {}

  hideBackdrop() {
    this.backdrop.hide();
  }
}
